import {get} from 'lodash'
import moment from 'moment'

export default {
  methods: {
    checkFieldUpdate ({newCompany, oldCompany, fieldDate, fieldFile}) {
      // checking permission to edit license without uploading a file
      // const userInfo = this.$store.getters.userInfo || {}
      const isFounder = true // userInfo.role === FOUNDER.id
      const newDate = get(newCompany, fieldDate, '')
      const oldDate = get(oldCompany, fieldDate, '')
      const newFile = get(newCompany, fieldFile, '')
      const oldFile = get(oldCompany, fieldFile, '')
      const estCardEqualDate = moment(newDate).isSame(oldDate)
      const estCardUpdateFile = newFile !== oldFile
      const validate = !oldDate || !newDate
      return validate || estCardEqualDate || estCardUpdateFile || isFounder
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixin/checkFieldUpdate.js